import { Tooltip as MantineTooltip } from '@mantine/core';
import type { TooltipProps as MantineTooltipProps } from '@mantine/core';
import './Tooltip.css';

export interface TooltipProps extends MantineTooltipProps {}

export default function Tooltip({ classNames, withArrow = true, zIndex = 1100, ...props }: TooltipProps) {
  const extra =
    classNames && typeof classNames === 'object'
      ? classNames
      : undefined;

  return (
    <MantineTooltip
      withArrow={withArrow}
      zIndex={zIndex}
      classNames={{
        tooltip: 'app-tooltip',
        arrow: 'app-tooltip-arrow',
        ...extra,
      }}
      {...props}
    />
  );
}
